import React from 'react';
import UpgradeTooltip from '../UpgradeTooltip';

/**
 * ROAR-5007 (AC11): the lock shown next to a control whose feature the company's plan doesn't
 * include, with the "requires an upgrade" hover. Pair it with disabling the control itself.
 */
const FeatureLockIcon = ({ testId }) => (
  <UpgradeTooltip>
    <img src="/images/FeatureLockIcon.svg" alt="Locked" data-testid={testId} className="w-5 h-5" />
  </UpgradeTooltip>
);

export default FeatureLockIcon;
